/**
 * Created by m.igrachev on 4/2/2018.
 */
import typeOfOperand from "../base/typeOfOperand";

export default function includesAtLeastOneOf(arr, toTest) {
    if (typeOfOperand(arr) !== "array") {
        //In case the first argument is not an array we return undefined.
        return;
    }
    if (toTest && typeOfOperand(toTest) === "array") {
        for (let item of toTest) {
            if (arr.includes(item)) {
                return true;
            }
        }
        return false;
    }

    return arr.includes(toTest);
}
